<template>
  <div class="pg-input-template">
    <PgInput
      :contentStyle="contentStyle"
      :placeholder="placeholder"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <ElButton type="text" class="pg-input-template__btn" @click="handleInput">{{
      btnText
    }}</ElButton>
  </div>
</template>
<script setup>
import PgInput from './input.vue'
const props = defineProps({
  contentStyle: Object,
  btnText: {
    type: String,
    default: '应用模板',
  },
  placeholder: String,
})

const emit = defineEmits(['input'])
const handleInput = () => {
  emit('input', props.placeholder)
}
</script>
<style lang="scss">
@import '../style/input-template.scss';
</style>
